import React, { useEffect, useState } from 'react'
import './App.scss'
import {
   Intro,
   Footer,
   Contact,
   Work,
   Navbar,
   AboutMe,
   Skill,
} from './components'
import { DotLoader as Loader } from 'react-spinners'

function App() {
   const [loading, setLoading] = useState(false)
   useEffect(() => {
      setLoading(true)
      setTimeout(() => {
         setLoading(false)
      }, 3000)
   }, [])
   return (
      <>
         {loading ? (
            <div className="loader">
               <Loader color="#ffd700" size={100} />
            </div>
         ) : (
            <div className="app">
               <Navbar />
               <div className="app__intro" id="intro">
                  <Intro />
               </div>
               <div className="app__about" id="about">
                  <AboutMe />
               </div>
               <div className="app__skills" id="skills">
                  <Skill />
               </div>
               <div className="app__work" id="work">
                  <Work />
               </div>
               <div className="app__contact" id="contact">
                  <Contact />
               </div>
               <div className="app__footer">
                  <Footer />
               </div>
            </div>
         )}
      </>
   )
}

export default App
